export enum CustomersFilterTypes {
  firstName = "firstName",
  lastName = "lastName",
  phoneNumber = "phoneNumber",
  lastOrderDate = "lastOrderDate",
  mostOrderValue = "mostOrderValue",
  createdAtAfter = "createdAtAfter",
  loyaltyLevel = "loyaltyLevel",
}

export enum CustomersFilterNames {
  firstName = "First name",
  lastName = "Last name",
  phoneNumber = "Phone number",
  lastOrderDate = "Last order date",
  mostOrderValue = "Most order value",
  createdAtAfter = "Created after",
  loyaltyLevel = "Loyalty level",
}

export enum Gender {
  Male = "male",
  Female = "female",
}

export enum CustomerGoal {
  Lose = "lose",
  Maintain = "maintain",
  Gain = "gain",
}

export enum CustomerActivityLevelGoal {
  Sedentary = "sedentary",
  Light_activity = "light_activity",
  Moderate_activity = "moderate_activity",
  Very_active = "very_active",
}

export type CustomerHealthData = {
  weight: number;
  height: number;
  goal: CustomerGoal;
  activityLevel: CustomerActivityLevelGoal;
  perWeekWeightChange: CustomerActivityLevelGoal;
  updatedAt: string;
};

export type CustomerHealthCalculations = {
  tdee: number;
  bmr: number;
  recommendedDailyCaloriesIntake: number;
  updatedAt: string;
};

export type CustomerProfileResponseDto = {
  id: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  email: string | null;
  gender: Gender | null;
  birthDate: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  healthData: CustomerHealthData | null;
  healthCalculations: CustomerHealthCalculations | null;
  isHealthDataQuestionnaireSkipped: boolean;
  emailVerified: boolean;
};

export type GetCustomersResponseDto = {
  totalCount: number;
  items: CustomerProfileResponseDto[];
};

export type CustomerMappedProfile = CustomerProfileResponseDto & {
  fullName: string | null;
};

export type GetCustomersMappedResponseDto = {
  totalCount: number;
  items: CustomerMappedProfile[];
};

export type CustomerBalanceResponseDto = {
  fmcCentsAmount: number | null;
  expiresAt: string | null;
};
